import type { NavigationGuard, NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useAuthStore } from '@kidzonet/pinia/UserStore'

declare global {
    interface Window {
        KIDZONET_VUE_I18N: any
    }
}

export const redirectToSavedURLOrGoToTheRequestedURL = (next: NavigationGuardNext) => {
    const nextUrl = localStorage.getItem('kidzonet-next-url-item')
    if (nextUrl) {
        localStorage.removeItem('kidzonet-next-url-item')
        window.location.href = nextUrl
    } else {
        next()
    }
}

export const saveRequestedUrlToLocalStorageAndRedirectToRootURL = (to: RouteLocationNormalized, next: NavigationGuardNext) => {
    if (to.meta.requiresAuth) {
        localStorage.setItem('kidzonet-next-url-item', window.location.href)
        next({
            path: '/',
        })
    } else {
        next()
    }
}

export const authGuardBeforeEachHook: NavigationGuard = async (to, from, next) => {
    const store = useAuthStore()
    if (store.isAuthenticated) {
        redirectToSavedURLOrGoToTheRequestedURL(next)
    } else {
        saveRequestedUrlToLocalStorageAndRedirectToRootURL(to, next)
    }
}

export const setNextPageTitleHook = (defaultTitle = 'Kidzonet'): NavigationGuard => async (to, from, next) => {
    if (!to.meta.title) {
        document.title = defaultTitle
    } else if (window.KIDZONET_VUE_I18N.te(to.meta.title)) {
        document.title = `${window.KIDZONET_VUE_I18N.t(to.meta.title)} | ${defaultTitle}`
    } else {
        let attempt = 1

        const timer = setInterval(() => {
            if (window.KIDZONET_VUE_I18N.te(to.meta.title)) {
                document.title = `${window.KIDZONET_VUE_I18N.t(to.meta.title)} | ${defaultTitle}`
                clearInterval(timer)
            } else if (attempt >= 10) {
                document.title = defaultTitle
                clearInterval(timer)
            }
            attempt = attempt + 1
        }, 200)
    }
    next()
}
